import { Color } from '@diritto/common/style/color';
import styled from '@emotion/styled';

export const StyledTopMenu = styled.nav`
  position: relative;
  background-color: ${Color.White};
  width: 100%;
`;
